export default {
    methods: {
        updateDialogWidth() {
            const screenWidth = window.innerWidth;
            if (screenWidth < 500) {
                this.dialogWidth = '80%';
            } else if (screenWidth < 600) {
                this.dialogWidth = '70%';
            } else if (screenWidth < 750) {
                this.dialogWidth = '60%';
            } else if (screenWidth < 910) {
                this.dialogWidth = '40%';
            } else if (screenWidth < 1150) {
                this.dialogWidth = '35%';
            } else if (screenWidth < 1477) {
                this.dialogWidth = '30%';
            } else if (screenWidth < 1700) {
                this.dialogWidth = '25%';
            } else {
                this.dialogWidth = '20%';
            }
        }
    }
};